import { Button, Icon } from "pepsico-ds";
import "./noResultsFound.scss";
const NoResultsFound = ({ onResetAllFilters, onChangeFilters }) => {
  const handleResetAllFilters = () => onResetAllFilters();
  const handleChangeFilters = () => onChangeFilters();

  return (
    <div className="no-results-found">
      <div className="no-results-found__icon">
        <Icon icon="info" alt="No Results Found" />
        <div className="no-results-found__content">
          <h2 className="no-results-found__title">No Results found</h2>
          <p className="no-results-found__description">Try removing some filters.</p>
        </div>
      </div>

      <div className="button-group">
        <div>
          <Button
            className="button"
            size="medium"
            text="Reset all filters"
            variant="secondary"
            onClick={handleResetAllFilters}
          />
        </div>
        <Button
          className="button"
          variant="primary"
          size="medium"
          text="Change filters"
          onClick={handleChangeFilters}
        />
      </div>
    </div>
  );
};

export default NoResultsFound;
